import type { ICancellationToken } from '@cian/http-api';

import {
  IPublicDesktopV2MapGetClustersRequest,
  IPublicDesktopV2MapGetClustersResponse200,
  IPublicDesktopV2MapGetClustersResponse400,
  createPublicDesktopV2MapGetClustersModel,
  fetchPublicDesktopV2MapGetClusters,
} from 'shared/repositories/commercial-listing-map/desktop/v2/map/get-clusters';
import { FetchAssertsService } from 'shared/services/FetchAssertsService';
import type { IApplicationContext } from 'shared/types/ApplicationContext';
import { GetRealClustersResponse } from 'shared/types/Clusters';
import { Cluster } from 'shared/types/Map';

type FetchServiceParams = {
  applicationContext: IApplicationContext;
  cancellationToken: ICancellationToken;
  parameters: IPublicDesktopV2MapGetClustersRequest;
};

export function fetchGetClustersService(params: FetchServiceParams): Promise<GetRealClustersResponse> {
  const {
    applicationContext: { httpApi, logger },
    cancellationToken,
    parameters,
  } = params;

  const fetchAssertsService = new FetchAssertsService(
    createPublicDesktopV2MapGetClustersModel(parameters),
    'src/shared/store/serverSide/commercial-listing-map/desktop/v2/map/get-clusters/internal/fetchService.ts',
    logger,
  );

  return fetchPublicDesktopV2MapGetClusters<
    IPublicDesktopV2MapGetClustersResponse200,
    IPublicDesktopV2MapGetClustersResponse400
  >({
    config: { cancellationToken },
    httpApi,
    parameters,
  }).then(
    result => {
      const statusCode = result.statusCode;

      switch (result.statusCode) {
        case 200:
          /**
           * Зачем это сделано.
           * Для уменьшения кол-ва данных, гоняемых по сети, мы убрали несколько технических полей из респонса,
           * которые нам нужны на фронте.
           * Эти поля мы добавляем здесь, мутируя ответ.
           */
          (result.response.clusters as Cluster[]).forEach(cluster => {
            cluster.type = 'Feature';
            cluster.geometry.type = 'Point';
          });

          return result.response as GetRealClustersResponse;
        case 400:
          throw fetchAssertsService.assert400StatusCodeError(result);
        default:
          throw fetchAssertsService.assertUnknownStatusCodeError(statusCode);
      }
    },
    error => {
      throw fetchAssertsService.assertUnknownServerError(error);
    },
  );
}
